module.exports = __webpack_public_path__ + "img/chat.958b0494.png";